import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'
class DBCoupon {
  // 获取优惠券列表
  getCouponList(options) {
    let url = `/api/db/coupon/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取优惠券详情
  getCouponDetail(couponId) {
    let url = `/api/db/coupon/detail?id=${couponId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取优惠券对应的商品列表
  getGoodListWithCoupon(options) {
    let url = `/api/db/coupon/detail/goods/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取优惠券对应已发放的客户列表
  getCustomerListWithCoupon(options) {
    let url = `/api/db/coupon/detail/cus/info?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 启用或停用优惠券
  updateCouponStatus(data) {
    const url = `/api/db/coupon/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 新增优惠券
  addCoupon(data) {
    const url = `/api/db/coupon/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 对指定用户发放优惠券
  assignCoupon(data) {
    const url = `/api/db/coupon/issuance`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 撤回优惠券
  postWithdraw(data) {
    const url = `/api/db/coupon/revoke`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
}
export default DBCoupon
